const barColor = [
  "rgba(21, 175, 208, 1)",
  "rgba(229, 191, 33, 1)",
];

const frameworkB2Options = {
  maintainAspectRatio: false,
  plugins: {
    tooltip: {
      callbacks: {
        label: function(context){
          return context.dataset.label+": "+context.parsed.y+"%"
        }
      }
    },
    datalabels: {
      display: false
    },
    title: {
      display: true,
      text: "Framework B: Dimension Accuracy",
      font: {
        size: 15
      }
    }
  },
  scales: {
    y: {
      min: 0,
      max: 100,
      ticks: {
        callback: function(value, index, values) {
          return value+"%";
        }
      }
    },
    x: {
      title: {
        display: true,
        text: "System"
      }
    }
  },
};

const frameworkB2Data = {
  labels: ["Aegis", "AGZ", "Caster", "C-Core", "FIQ", "SCORE", "SRD", "ARTCC"],
  datasets: [
    {
      label: "Autonomy",
      backgroundColor: [barColor[0], barColor[0], barColor[0], barColor[0], barColor[0],
        barColor[0], barColor[0], barColor[0].replace(", 1)", ", 0.2")],
      borderColor: barColor[0],
      data: [78, 76, 34, 25, 38, 52, 38, 31],
      borderWidth: 1,
    },
    {
      label: "Impact",
      backgroundColor: [barColor[1], barColor[1], barColor[1], barColor[1], barColor[1],
        barColor[1], barColor[1], barColor[1].replace(", 1)", ", 0.2")],
      borderColor: barColor[1],
      data: [97, 97, 41, 63, 63, 61, 78, 60],
      borderWidth: 1,
    }
  ],
};

export {frameworkB2Data, frameworkB2Options};